import groq from 'groq';
import { portableTextWithReferences } from '../portableTextWithReferences';

/**
 * Explicit confirmation projection — avoids GROQ field shadowing on `type` and
 * supports documents saved before the schema field was renamed to confirmationType.
 */
export const formConfirmationFields = (contentBlocksProjection: string) => groq`
  "confirmationType": coalesce(confirmationType, type),
  contentRedirectUrl,
  contentMessage[] {
    ${portableTextWithReferences}
  },
  contentBlocks[] {
    ${contentBlocksProjection}
  }
`;

export const formConfirmationFieldsSimple = groq`
  "confirmationType": coalesce(confirmationType, type),
  contentRedirectUrl,
  contentMessage[] {
    ${portableTextWithReferences}
  }
`;

export function getStoredConfirmationType(
  confirmation?: { confirmationType?: string; type?: string } | null,
): string | undefined {
  return confirmation?.confirmationType ?? confirmation?.type;
}
